<div class="main-container-add-soil-sample">
    <div *ngIf="isAddNewSapleMode" class="header-container-add-edit-soil-sample">
        <span><img src="../../assets/icons/new_pin_updated.png" alt="New Pin Icon" class="add-edit-soil-sample-header-icon"> </span>
        <h1 mat-dialog-title  class="add-edit-soil-sample-header">{{ 'ADD-EDIT-NEW-SAMPLE-DIALOG.NEW-SAMPLE' | translate }}</h1>
    </div>
    <div *ngIf="isEditSampleMode" class="header-container-add-edit-soil-sample">
        <span><img src="../../assets/icons/new_pin_updated.png" alt="New Pin Icon" class="add-edit-soil-sample-header-icon"> </span>
        <h1 mat-dialog-title  class="add-edit-soil-sample-header">{{ 'ADD-EDIT-NEW-SAMPLE-DIALOG.EDIT-SAMPLE' | translate }}</h1>
    </div>
    <form [formGroup]="soilSampleForm">
    <div class="add-edit-soil-sample-input-container">
        <mat-form-field class="add-edit-soil-sample-input" appearance="outline">
            <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.SAMPLE-ID' | translate }}</mat-label>
            <input matInput formControlName="sampleName">
                <mat-error *ngIf="soilSampleForm.get('sampleName').invalid && soilSampleForm.get('sampleName').touched"  class="error-notice">
                       <strong class="item-required-text">Required* - id/Name</strong>
                </mat-error>
        </mat-form-field>
    </div>
    
    <div class="add-edit-soil-sample-input-container">
        <mat-form-field class="add-edit-soil-sample-input" appearance="outline">
            <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.SAMPLE-DEPTH' | translate }}</mat-label>
            <input matInput formControlName="sampleDepth" type="number">
        </mat-form-field>
    </div>
    
    <div class="add-edit-soil-sample-input-container">
        <mat-form-field class="add-edit-soil-sample-input" appearance="outline">
            <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.ROCK' | translate }}</mat-label>
            <input matInput formControlName="rockPercentage" type="number">
        </mat-form-field>
    </div>
    
    <textarea formControlName="note"  class="soil-sample-note-text-area"  placeholder="Note:"  rows="4" cols="50" wrap="soft"></textarea>
    
    <div class="add-edit-soil-sample-input-container">
        <mat-form-field class="add-edit-soil-sample-input" appearance="outline">
            <mat-label>{{'ADD-EDIT-NEW-SAMPLE-DIALOG.GROUP' | translate }}</mat-label>
            <mat-select formControlName="pinSampleGroup" (selectionChange)="updateSampleGroup($event.value);" >
                <mat-option style="background-color: white!important; padding: 8px!important">
                    <div class="select-search-container-sm">
                        <div class="select-search-sm">
                    <ngx-mat-select-search placeholderLabel="Search Group" [formControl]="groupFilterCtrl">
                        <span ngxMatSelectNoEntriesFound>
                            No entries found
                        </span>
                    </ngx-mat-select-search>
                   
                  </div>
                </div>

                </mat-option>
                <mat-option *ngFor="let group of filteredSampleGroups | async | orderBy: 'name'"  [value]="group">
                    {{group.name}}{{group.isGrid ? " - Grid" : ""}}
                  </mat-option>

            </mat-select>
                   <mat-error *ngIf="soilSampleForm.get('pinSampleGroup').invalid && soilSampleForm.get('pinSampleGroup').touched" class="error-notice">
                       <strong class="item-required-text">Required* - group </strong>  
                   </mat-error>
        </mat-form-field>
    
        <div class="add-edit-soil-sample-add-job-container">
            <button class="add-edit-soil-sample-add-job-btn" mat-flat-button type="button" (click)="addNewGroup()">
                <span class="material-icons" style="color: white; font-size: 24px;">add</span>
            </button>
        </div>
    </div>
    </form>

    <div class="add-edit-soil-sample-input-container" *ngIf="definitions?.length > 1 || isOrphanedLink">
        <div class="orphaned-warning" *ngIf="isOrphanedLink">
            <mat-icon class="orphaned-icon">warning</mat-icon>
            <span>Linked definition was removed — please reassign</span>
        </div>
        <mat-form-field class="add-edit-soil-sample-input" appearance="outline">
            <mat-label>Crop Definition</mat-label>
            <mat-select [(ngModel)]="selectedDefinitionId">
                <mat-option [value]="null">— None —</mat-option>
                <mat-option *ngFor="let def of definitions" [value]="def.id">
                    {{def.cultivar || 'Definition'}} {{def.cropDescription ? '(' + def.cropDescription + ')' : ''}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-checkbox *ngIf="isEditSampleMode" [(ngModel)]="isCompleted" class="example-margin">Mark as Completed.</mat-checkbox>
    
    <div mat-dialog-actions *ngIf="isAddNewSapleMode">
        <button mat-flat-button (click)="cancel()" type="button" class="cancel-add-edit-soil-sample">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.CANCEL' | translate }}</button>
        <button class="add-edit-soil-sample-save-btn"  [disabled]="soilSampleForm.invalid"  [ngClass]="{'disabled-save-btn': soilSampleForm.invalid}" mat-flat-button (click)="saveSample()">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.SAVE' | translate }}</button>
    </div>
    
    <div mat-dialog-actions *ngIf="isEditSampleMode">
        <button mat-flat-button (click)="cancel()" type="button" class="cancel-edit-sample">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.CANCEL' | translate }}</button>
        <button class="add-edit-soil-sample-delete-btn" mat-flat-button (click)="deleteSample()">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.DELETE' | translate }}</button>
        <button class="add-edit-soil-sample-update-btn" mat-flat-button (click)="updateSample()">{{'ADD-EDIT-NEW-SAMPLE-DIALOG.UPDATE' | translate }}</button>
    </div>

</div>

